<script setup lang="ts">
import { DropdownMenuLabel as L } from 'reka-ui';
</script>

<template>
  <L class="px-3 py-1.5 text-micro uppercase tracking-wide text-text-muted">
    <slot />
  </L>
</template>
